import React,{useState,useEffect} from 'react'
import axios from 'axios'
import Panel from '../ui/Panel'
import Bar from '../ui/Bar'
import './dashboard.css'

export default function DashboardSearchedPositions() {
    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(true)
    const [view,setView]=useState('chart')

    // 0 .. next round step above the tallest bar, so the longest bar never
    // touches the end of its track.
    const getXAxisMax = (rows) => {
      if (!rows.length) return 10
      const maxValue = Math.max(...rows.map(item => Number(item.value) || 0))
      const step = 10
      const roundedMax = Math.ceil(maxValue / step) * step
      return roundedMax + step
    }

    const axisMax = getXAxisMax(data)

    useEffect(()=>{
        loadData()
    },[])

    const loadData=()=>{
        //setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'manager/dashboard/searchedpositions/'+sessionStorage.getItem('userToken'),{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
              }
          })
        .then(res=>{
            //console.log(res.data)
            setIsLoading(false)
            setData(res.data.results)
        }).catch(err=>{
            setIsLoading(false)

        })
      }

      const ticks=[0,1,2,3].map(i=>Math.round((axisMax/3)*i))

      const isFlat=data.length>1 && data.every(item=>Number(item.value)===Number(data[0].value))

      const tools=(
        <>
          <button
            className="toggle"
            type="button"
            aria-pressed={view==='chart'}
            onClick={()=>setView('chart')}
          >Chart</button>
          <button
            className="toggle"
            type="button"
            aria-pressed={view==='table'}
            onClick={()=>setView('table')}
          >Table</button>
        </>
      )

  return (
    <Panel
      title="Positions you search more"
      subtitle="Share of your searches, by position"
      actions={data.length>0 ? tools : null}
    >
        {isLoading &&
          <div className="sk-list">
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line short"></div>
          </div>
        }

        {!isLoading && data.length===0 &&
          <div className="empty">No searches recorded yet.</div>
        }

        {!isLoading && data.length>0 &&
          <>
            <div className="bars" hidden={view!=='chart'}>
                {data.map((item,index)=>(
                  <Bar
                    key={item.label || index}
                    label={item.label}
                    value={Number(item.value) || 0}
                    max={axisMax}
                    display={`${item.value}%`}
                    delay={0.05+index*0.06}
                  />
                ))}

                <div className="axis" aria-hidden="true">
                  {ticks.map(tick=><span key={tick}>{tick}%</span>)}
                </div>

                {isFlat &&
                  <p className="callout">
                    Demand is <b>perfectly flat</b> — all {data.length} positions sit at {data[0].value}%.
                    Either your search habits are evenly spread, or the filter isn't being used to
                    narrow by position at all.
                  </p>
                }
            </div>

            <div hidden={view!=='table'}>
                <table className="tbl">
                  <caption>Share of searches by position</caption>
                  <thead>
                    <tr>
                      <th scope="col">Position</th>
                      <th scope="col" style={{textAlign:'right'}}>Share</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item,index)=>(
                      <tr key={item.label || index}>
                        <td>{item.label}</td>
                        <td className="n">{item.value}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
            </div>
          </>
        }
    </Panel>
  )
}
